import { render, staticRenderFns } from "./NoticeView.vue?vue&type=template&id=413c4e52&"
import script from "./NoticeView.vue?vue&type=script&lang=js&"
export * from "./NoticeView.vue?vue&type=script&lang=js&"
import style0 from "./NoticeView.vue?vue&type=style&index=0&id=413c4e52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports